module.exports = __webpack_public_path__ + "img/المان-مرتبط.c40a3de3.jpg";